var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"icon has-text-primary is-large"},[_c('i',{staticClass:"fa-2x fa-lg",class:_vm.icon})]),_c('h1',{staticClass:"title is-5"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }